package com.sweetlime.bingeamigo.presentation.features.user

import androidx.lifecycle.ViewModel
import androidx.lifecycle.viewModelScope
import com.sweetlime.bingeamigo.repository.LibraryRepository
import com.sweetlime.bingeamigo.repository.ReviewRepository
import com.sweetlime.bingeamigo.repository.UserRepository
import com.sweetlime.bingeamigo.state.UserProfileUiState
import kotlinx.coroutines.flow.MutableStateFlow
import kotlinx.coroutines.flow.StateFlow
import kotlinx.coroutines.flow.asStateFlow
import kotlinx.coroutines.flow.update
import kotlinx.coroutines.launch

class UserProfileViewModel(
    private val profileRepository: UserRepository,
    private val libraryRepository: LibraryRepository,
    private val reviewRepository: ReviewRepository,
) : ViewModel() {

    private val _uiState = MutableStateFlow(UserProfileUiState())
    val uiState: StateFlow<UserProfileUiState> = _uiState

    private val _communityRatings = MutableStateFlow<Map<Int, Double>>(emptyMap())
    val communityRatings: StateFlow<Map<Int, Double>> = _communityRatings.asStateFlow()

    private var currentUserId: String = ""

    fun loadUser(userId: String) {
        currentUserId = userId

        viewModelScope.launch {
            _uiState.update { it.copy(loading = true) }

            try {
                val profile = profileRepository.getUserProfile(userId)
                val favorites = libraryRepository.getUserFavorites(userId)
                val activity = profileRepository.getUserActivity(userId)
                val isFollowing = profileRepository.isFollowing(userId)
                val followers = profileRepository.getFollowers(userId)
                val following = profileRepository.getFollowing(userId)

                _uiState.update {
                    it.copy(
                        profile = profile,
                        favorites = favorites,
                        activity = activity,
                        isFollowing = isFollowing,
                        followersCount = followers.size,
                        followingCount = following.size,
                        loading = false
                    )
                }

                if (favorites.isNotEmpty()) {
                    val docIds = favorites.map { "MOVIE_${it.id}" }
                    val summaries = reviewRepository.getContentSummaries(docIds)
                    _communityRatings.value = summaries.mapNotNull { (key, summary) ->
                        if (summary.avgRating > 0.0) key.removePrefix("MOVIE_").toIntOrNull()?.let { id -> id to summary.avgRating } else null
                    }.toMap()
                }
            } catch (e: Exception) {
                _uiState.update { it.copy(loading = false) }
            }
        }
    }

    fun followUser() {
        viewModelScope.launch {
            try {
                val profile = profileRepository.getUserProfile(currentUserId)
                profileRepository.followUser(profile!!)
                _uiState.update { it.copy(isFollowing = true, followersCount = it.followersCount + 1) }
            } catch (_: Exception) {}
        }
    }

    fun unfollowUser() {
        viewModelScope.launch {
            try {
                profileRepository.unfollowUser(currentUserId)
                _uiState.update { it.copy(isFollowing = false, followersCount = maxOf(0, it.followersCount - 1)) }
            } catch (_: Exception) {}
        }
    }
}
